import dayjs from "dayjs";
import {SurgeryRequestItem} from "../types/surgeryRequests";

export const canEditSurgeryRequest = (item: SurgeryRequestItem, userId?: string): boolean =>
  !!userId && item.createdById === userId && dayjs(item.operationTime).isAfter(dayjs());
